const SOUND_SETTINGS_KEY = 'mk_sound_settings';
const DEFAULT_SOUND_SETTINGS = {
  enabled: true,
  priceAlerts: true,
  orderSuccess: true,
  orderFailure: true,
  volume: 0.35
};

export function getSoundSettings() {
  try {
    const stored = JSON.parse(localStorage.getItem(SOUND_SETTINGS_KEY) || '{}');
    return { ...DEFAULT_SOUND_SETTINGS, ...(stored && typeof stored === 'object' ? stored : {}) };
  } catch (error) {
    return { ...DEFAULT_SOUND_SETTINGS };
  }
}

export function saveSoundSettings(settings) {
  const next = { ...DEFAULT_SOUND_SETTINGS, ...settings };
  try { localStorage.setItem(SOUND_SETTINGS_KEY, JSON.stringify(next)); } catch (error) {}
  window.dispatchEvent(new CustomEvent('mk-sound-settings-changed', { detail: next }));
  return next;
}

export function playSound(kind = 'priceAlert', force = false) {
  const settings = getSoundSettings();
  const preference = kind === 'orderSuccess' ? 'orderSuccess' : kind === 'orderFailure' ? 'orderFailure' : 'priceAlerts';
  if (!force && (!settings.enabled || !settings[preference])) return false;
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return false;
    const context = new AudioContextClass();
    const now = context.currentTime;
    const patterns = {
      priceAlert: [{ f: 880, t: 0, d: 0.13 }, { f: 1175, t: 0.17, d: 0.16 }],
      orderSuccess: [{ f: 660, t: 0, d: 0.10 }, { f: 880, t: 0.12, d: 0.14 }],
      orderFailure: [{ f: 330, t: 0, d: 0.18 }, { f: 247, t: 0.22, d: 0.2 }]
    };
    (patterns[kind] || patterns.priceAlert).forEach((tone) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(tone.f, now + tone.t);
      gain.gain.setValueAtTime(0.0001, now + tone.t);
      gain.gain.exponentialRampToValueAtTime(Math.max(0.001, Number(settings.volume) || 0.35) * 0.18, now + tone.t + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + tone.t + tone.d);
      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(now + tone.t);
      oscillator.stop(now + tone.t + tone.d + 0.02);
    });
    window.setTimeout(() => { try { context.close(); } catch (error) {} }, 900);
    return true;
  } catch (error) {
    return false;
  }
}
